import React, { useMemo, useState } from 'react';
import './AvatarLoreleiPreview.css';

const LORELEI_HAIR = ['variant01', 'variant06', 'variant12', 'variant20', 'variant31', 'variant44'];
const OPEN_PEEPS_HEAD = [
  ['afro', 'Afro'],
  ['bangs', 'Kakül'],
  ['bun', 'Topuz'],
  ['cornrows', 'Örgü'],
  ['longCurly', 'Uzun kıvırcık'],
  ['short1', 'Kısa'],
  ['hatBeanie', 'Bere'],
  ['hatHip', 'Şapka'],
];
const SKIN = ['f2d3b1', 'e9b98d', 'd8996e', 'a66b49', '70472f'];
const HAIR_COLORS = ['211b19', '5c3826', '9a5a2e', 'd7a45a', '494044', '762f7b'];
const CLOTHING_COLORS = ['8fa7df', '78e185', 'ffcf77', 'e279c7', 'e78276', '9ddadb'];
const LORELEI_EXPRESSIONS = ['happy01', 'happy04', 'happy10', 'happy17'];
const OPEN_PEEPS_EXPRESSIONS = ['smile', 'smileBig', 'calm', 'cute'];
const LORELEI_GLASSES = ['', 'variant01', 'variant02', 'variant03', 'variant04', 'variant05'];
const OPEN_PEEPS_GLASSES = ['', 'glasses', 'glasses2', 'glasses3', 'glasses4', 'glasses5'];
const BACKGROUNDS = ['fce7f3', 'dbeafe', 'dcfce7', 'fef3c7'];

function ChoiceGroup({ label, values, value, onChange, format = (item) => item, color = false }) {
  return (
    <fieldset className="lorelei-choice-group">
      <legend>{label}</legend>
      <div className="lorelei-choices">
        {values.map((item, index) => (
          <button
            key={`${label}-${item || 'none'}`}
            type="button"
            className={`lorelei-choice${item === value ? ' is-selected' : ''}${color ? ' is-color' : ''}`}
            aria-label={`${label}: ${format(item, index)}`}
            aria-pressed={item === value}
            onClick={() => onChange(item)}
            title={format(item, index)}
            style={color ? { backgroundColor: `#${item}` } : undefined}
          >
            {color ? <span className="lorelei-color-label">{format(item, index)}</span> : format(item, index)}
          </button>
        ))}
      </div>
    </fieldset>
  );
}

export default function AvatarStylePreview() {
  const [style, setStyle] = useState('lorelei');
  const [hair, setHair] = useState(LORELEI_HAIR[0]);
  const [head, setHead] = useState(OPEN_PEEPS_HEAD[0][0]);
  const [skin, setSkin] = useState(SKIN[1]);
  const [hairColor, setHairColor] = useState(HAIR_COLORS[1]);
  const [clothingColor, setClothingColor] = useState(CLOTHING_COLORS[0]);
  const [loreleiExpression, setLoreleiExpression] = useState(LORELEI_EXPRESSIONS[0]);
  const [openPeepsExpression, setOpenPeepsExpression] = useState(OPEN_PEEPS_EXPRESSIONS[0]);
  const [loreleiGlasses, setLoreleiGlasses] = useState('');
  const [openPeepsGlasses, setOpenPeepsGlasses] = useState('');
  const [background, setBackground] = useState(BACKGROUNDS[0]);

  const avatarUrl = useMemo(() => {
    const params = new URLSearchParams({ seed: 'DANDU-avatar-deneme', skinColor: skin, backgroundColor: background });
    if (style === 'lorelei') {
      params.set('hairVariant', hair);
      params.set('hairColor', hairColor);
      params.set('mouthVariant', loreleiExpression);
      params.set('glassesProbability', loreleiGlasses ? '100' : '0');
      params.set('earringsProbability', '0');
      params.set('hairAccessoriesProbability', '0');
      params.set('beardProbability', '0');
      if (loreleiGlasses) params.set('glassesVariant', loreleiGlasses);
    } else {
      params.set('headVariant', head);
      params.set('clothingColor', clothingColor);
      params.set('expressionVariant', openPeepsExpression);
      params.set('accessoriesProbability', openPeepsGlasses ? '100' : '0');
      params.set('facialHairProbability', '0');
      params.set('maskProbability', '0');
      if (openPeepsGlasses) params.set('accessoriesVariant', openPeepsGlasses);
    }
    return `https://api.dicebear.com/10.x/${style}/svg?${params.toString()}`;
  }, [style, hair, head, skin, hairColor, clothingColor, loreleiExpression, openPeepsExpression, loreleiGlasses, openPeepsGlasses, background]);

  const styleName = style === 'lorelei' ? 'Lorelei' : 'Open Peeps';

  return (
    <main className="lorelei-preview">
      <div className="lorelei-preview-content">
        <header>
          <p className="lorelei-eyebrow">DANDU avatar denemesi</p>
          <h1>Avatar stillerini karşılaştırın</h1>
          <p>Lorelei ve Open Peeps seçeneklerini büyük görünümde ve akıllı tahta kartı boyutunda inceleyin.</p>
        </header>

        <div className="lorelei-style-switch" role="group" aria-label="Avatar stili">
          <button type="button" className={style === 'lorelei' ? 'is-selected' : ''} aria-pressed={style === 'lorelei'} onClick={() => setStyle('lorelei')}>Lorelei</button>
          <button type="button" className={style === 'open-peeps' ? 'is-selected' : ''} aria-pressed={style === 'open-peeps'} onClick={() => setStyle('open-peeps')}>Open Peeps</button>
        </div>

        <div className="lorelei-layout">
          <section className="lorelei-preview-panel" aria-label="Avatar önizlemesi">
            <div className="lorelei-large-avatar">
              <img src={avatarUrl} alt={`Seçilen ${styleName} avatarı`} />
            </div>
            <div className="lorelei-board-card">
              <img src={avatarUrl} alt={`Akıllı tahta kartında küçük ${styleName} avatarı`} />
              <span>Öğrenci kartı önizlemesi</span>
            </div>
            <p className="lorelei-preview-note">Bu deneme puan harcamaz ve seçimleri kaydetmez.</p>
          </section>

          <section className="lorelei-controls" aria-label="Avatar seçenekleri">
            {style === 'lorelei' ? (
              <ChoiceGroup label="Saç modeli" values={LORELEI_HAIR} value={hair} onChange={setHair} format={(_, index) => `Model ${index + 1}`} />
            ) : (
              <ChoiceGroup label="Saç ve şapka" values={OPEN_PEEPS_HEAD.map(([value]) => value)} value={head} onChange={setHead} format={(item) => OPEN_PEEPS_HEAD.find(([value]) => value === item)?.[1] || item} />
            )}
            <ChoiceGroup label="Ten rengi" values={SKIN} value={skin} onChange={setSkin} format={(_, index) => `Ton ${index + 1}`} color />
            {style === 'lorelei' ? (
              <ChoiceGroup label="Saç rengi" values={HAIR_COLORS} value={hairColor} onChange={setHairColor} format={(_, index) => `Renk ${index + 1}`} color />
            ) : (
              <ChoiceGroup label="Kıyafet rengi" values={CLOTHING_COLORS} value={clothingColor} onChange={setClothingColor} format={(_, index) => `Renk ${index + 1}`} color />
            )}
            {style === 'lorelei' ? (
              <ChoiceGroup label="İfade" values={LORELEI_EXPRESSIONS} value={loreleiExpression} onChange={setLoreleiExpression} format={(_, index) => `İfade ${index + 1}`} />
            ) : (
              <ChoiceGroup label="İfade" values={OPEN_PEEPS_EXPRESSIONS} value={openPeepsExpression} onChange={setOpenPeepsExpression} format={(item) => ({ smile: 'Gülümseme', smileBig: 'Büyük gülümseme', calm: 'Sakin', cute: 'Neşeli' }[item])} />
            )}
            {style === 'lorelei' ? (
              <ChoiceGroup label="Gözlük" values={LORELEI_GLASSES} value={loreleiGlasses} onChange={setLoreleiGlasses} format={(item, index) => item ? `Gözlük ${index}` : 'Yok'} />
            ) : (
              <ChoiceGroup label="Gözlük" values={OPEN_PEEPS_GLASSES} value={openPeepsGlasses} onChange={setOpenPeepsGlasses} format={(item, index) => item ? `Gözlük ${index}` : 'Yok'} />
            )}
            <ChoiceGroup label="Arka plan" values={BACKGROUNDS} value={background} onChange={setBackground} format={(_, index) => `Renk ${index + 1}`} color />
            {style === 'open-peeps' && <p className="lorelei-style-note">Open Peeps’te şapka, saçtan bağımsız takılamaz; şapka seçimi saç modelini değiştirir.</p>}
          </section>
        </div>
      </div>
    </main>
  );
}
